import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/ProductList.css";
import Profile from './Profile';
import axios from 'axios';
import { prt } from "./prt";

const ProductList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        axios.get(`${prt}/products`)
            .then((response) => {
                const productsWithAverageStars = response.data.map(product => {
                    const stars = product.stars || []; 
                    const averageStars = stars.length > 0 ? parseFloat((stars.reduce((a, b) => a + b, 0) / stars.length).toFixed(2)) : 0; 
                    return { ...product, averageStars };
                });
                const sortedProducts = productsWithAverageStars.sort((a, b) => b.averageStars - a.averageStars);
                setProducts(sortedProducts);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching products:", error);
                setLoading(true);
            });
    }, []);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredProducts = products.filter((product) => {
        const nameMatches = product.name.toLowerCase().includes(searchQuery.toLowerCase());
        const priceMatches = String(product.price).includes(searchQuery);
        return nameMatches || priceMatches;
    });

    return (
        <div className="landing-page">
            <div className="header">
                <div>
                    <Link to="/" className="logo">ECommerce</Link>
                </div>
                <input
                    type="text"
                    placeholder="Search products..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="search-bar"
                />
                <div className="user-profile">
                    <Link onClick={toggleModal}>
                        <img
                            src="/imgs/dp.png"
                            alt="Profile"
                            style={{ borderRadius: '100%', height: '40px' }}
                        />
                    </Link>
                    {isOpen && (
                        <div className="modal">
                            <div className="modal-content">
                                <span className="close" onClick={toggleModal}>&times;</span>
                                <Profile />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="product-list">
                {loading ? (
                    Array.from({ length: 8 }).map((_, index) => (
                        <div className="product-item skeleton" key={index}>
                            <div className="skeleton-img"></div>
                            <p className="skeleton-text"></p>
                            <p className="skeleton-text"></p>
                            <div className="skeleton-button"></div>
                        </div>
                    ))
                ) : (
                    filteredProducts.map((product) => (
                        <div className="product-item" key={product.id}>
                            <img src={product.image} alt={product.name} />
                            <h3>{product.name}</h3>
                            <p>Price: ₹{product.price}</p>
                            <p>Average Rating: {product.averageStars.toFixed(1)}</p>
                            <Link to={`/products/${product.id}`}>View Details</Link>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ProductList;